import { render, staticRenderFns } from "./picturegif.vue?vue&type=template&id=590cf148&scoped=true&"
import script from "./picturegif.vue?vue&type=script&lang=js&"
export * from "./picturegif.vue?vue&type=script&lang=js&"
import style0 from "./picturegif.vue?vue&type=style&index=0&id=590cf148&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590cf148",
  null
  
)

component.options.__file = "picturegif.vue"
export default component.exports